module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "control lxm-login-input",
    class: _vm.controlClass,
    on: {
      "click": _vm.clicked
    }
  }, [_c('input', {
    ref: "input",
    staticClass: "input",
    class: _vm.inputClass,
    attrs: {
      "type": _vm.type,
      "placeholder": _vm.placeholderGetter
    },
    domProps: {
      "value": _vm.valueGetter
    },
    on: {
      "input": _vm.inputted,
      "change": _vm.changed,
      "blur": _vm.blurred,
      "focus": _vm.focused
    }
  }), _vm._v(" "), (_vm.label) ? _c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasError),
      expression: "hasError"
    }],
    ref: "error",
    staticClass: "lxm-login-input__error"
  }, [_c('img', {
    attrs: {
      "src": require("../../images/login/error.png")
    }
  }), _vm._v("\n    " + _vm._s(_vm.errorGetter) + "\n  ")]), _vm._v(" "), (_vm.help) ? _c('span', {
    staticClass: "help"
  }, [_vm._v(_vm._s(_vm.help))]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2babc09f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2babc09f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/common/InputBase.vue
// module id = 830
// module chunks = 0